import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCriticalItemsFromApi } from "../../api/NewsApi";

type CriticalItemsState = {
    loaded: boolean;
    items: any[];
    error: string;
}

const initialState: CriticalItemsState = {
    loaded: false,
    items: [],
    error: ''
}

const criticalItemsSlice = createSlice({
    name: 'criticalItems',
    initialState: initialState,
    reducers: {
        markCriticalItemAsRead: (state, action: PayloadAction<any>) => {
            state.items = [...state.items.filter((s: any) => s.id !== action.payload.id)]
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getCriticalItems.pending, state => {
                state.loaded = false;
            })
            .addCase(getCriticalItems.fulfilled, (state, action: any) => {
                state.loaded = true;
                state.items = action.payload;
            })
            .addCase(getCriticalItems.rejected, state => {
                state.error = "Unable to fetch data sources";
                state.loaded = false;
            })
    }
})

export const getCriticalItems = createAsyncThunk(
    "criticalItems/getDataSources",
    async () => {
        return await fetchCriticalItemsFromApi();
    }
)

export default criticalItemsSlice.reducer;
export const { markCriticalItemAsRead } = criticalItemsSlice.actions;

export const selectCriticalItems = (state: any) => state.criticalItems.items;
export const selectIfCriticalItemsLoaded = (state: any) => state.criticalItems.loaded;
export const selectCriticalItemsLoadingError = (state: any) => state.criticalItems.error;